module.exports = __webpack_public_path__ + "media/images/call-51b7212775eadf1393f5d30e795dd961.svg";